import styled from 'styled-components'

export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  svg {
    color: #4c4c4c;
    background-color: #f0f0f0;
    border-radius: 8px;
    padding: 9px 10px;
    margin-right: 16px;
    font-size: 14px;
    cursor: pointer;
  }
`

export const Subtitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
`

export const Label = styled.div`
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 4px;
  color: #757575;
`
